<template>
  <svg
    data-v-2836fdb5-s=""
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
  >
    <!--
    This icon is taken from Font Awesome Free 6.3.0, because it looks nice and Heroicons does
    not have a similar icon. The icon is licensed under Creative Commons. Here is the attribution notice:

    Font Awesome Free 6.3.0 by @fontawesome - https://fontawesome.com
    License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
    Copyright 2023 Fonticons, Inc.
  -->
    <path
      fill="currentColor"
      d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
    ></path>
  </svg>
</template>
